import { zodResolver } from '@hookform/resolvers/zod'
import { Icon } from '@iconify/react'
import { Alert, Box, Button, Grid, Typography } from '@mui/material'
import { useCallback, useContext, useEffect } from 'react'
import { useFieldArray, useForm } from 'react-hook-form'
import toast from 'react-hot-toast'
import { useNavigate } from 'react-router-dom'
import CardActions from '../../components/CardActions'
import { ContextOperacionNuevo, ContextOperacionNuevoType } from '../../NuevoSistema'
import { HttpLEP } from './api/httpLEP'
import { OperacionLEPLimitesNuevosTabla } from "./components/OperacionLEPLimitesNuevosTabla"
import { SeccionNuevoLEPDatosOperacion } from "./components/SeccionNuevoLEPDatosOperacion"
import { OperacionLEPInsert, schemaOperacionLEPInsert } from "./types/dto"
import { OperacionLEPEmisorFields, OperacionLEPFields } from "./types/fields"
import { useSubmitOperacion } from '../../hooks/useSubmitOperacion'

interface NuevoSistemaLEPProps {
  codSistemaPrincipal: number
}

const NuevoSistemaLEP = ({ codSistemaPrincipal }: NuevoSistemaLEPProps) => {
  const { submitOperacion } = useSubmitOperacion();

  const formMethods = useForm<OperacionLEPInsert>({
    resolver: zodResolver(schemaOperacionLEPInsert),
    defaultValues: {
      [OperacionLEPFields.FechaAprobacion]: new Date(),
      [OperacionLEPFields.CodPais]: codSistemaPrincipal,
      [OperacionLEPFields.Emisores]: []
    }
  })

  const { fields, append, remove } = useFieldArray({
    control: formMethods.control,
    name: OperacionLEPFields.Emisores
  })

  const handleCrearOperacion = useCallback(
    (data: OperacionLEPInsert) => {
      submitOperacion(data, {
        apiCall: HttpLEP.post,
        codSistemaPrincipal,
      });
    },
    [codSistemaPrincipal, submitOperacion]
  );

  const { setSavePromise, setSendPromise, codSistema } = useContext<ContextOperacionNuevoType>(ContextOperacionNuevo)

  useEffect(() => {
    setSendPromise(() => formMethods.handleSubmit(handleCrearOperacion))
  }, [formMethods, handleCrearOperacion, setSavePromise, setSendPromise])

  const handleAddEmisor = () => {
    append({ [OperacionLEPEmisorFields.RazonSocial]: '', [OperacionLEPEmisorFields.CodOperacionLEPEmisorTipo]: 0 })
  }

  return (
    <Box>
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <SeccionNuevoLEPDatosOperacion formMethods={formMethods} codSistema={codSistema} codPais={codSistemaPrincipal} />
        </Grid>
        <Grid item xs={12}>
          <CardActions title='Emisores y Límites' colapsable>
            {fields.length === 0 ? (
              <Alert severity='info'>No se han agregado emisores.</Alert>
            ) : (
              <OperacionLEPLimitesNuevosTabla fields={fields} control={formMethods.control}
                remove={remove} codSistema={codSistema} />
            )}
            <Button variant='outlined' startIcon={<Icon icon='tabler:plus' />} onClick={handleAddEmisor}
              sx={{ mt: 4 }}>
              Agregar Emisor
            </Button>
            {formMethods.formState.errors.emisores && (
              <Typography color='error' variant='caption' sx={{ display: 'block', mt: 1 }}>
                {formMethods.formState.errors.emisores.message}
              </Typography>
            )}
          </CardActions>
        </Grid>
      </Grid>
    </Box>
  )
}

export default NuevoSistemaLEP
